<template>
  <v-container class="in-journey-accordion-summary">
    <div class="bordered-section" :class="colorClass">
      <div class="left">
        <p>{{ summary.title }}</p>
      </div>
      <div class="right">
        <p>R {{ summary.price | currency }}</p>
      </div>
    </div>
    <div
      @click="summaryClicked"
      v-html="summary.description"
      class="description-section"
    ></div>
  </v-container>
</template>

<script>
  export default {
    name: 'InJourneyAccordionSummary',
    props: {
      summary: {
        required: true,
        type: Object,
      },
    },
    data() {
      return {};
    },
    computed: {
      colorClass() {
        switch (this.summary.product) {
          case 'Estate':
            return 'estate-assist-color';
          case 'Edu':
            return 'education-assist-color';
          case 'Debt':
            return 'debt-assist-color';
          case 'Cash':
            return 'cash-assist-color';
          case 'Cost':
            return 'cost-assist-color';
          case 'Tax':
            return 'tax-assist-color';
          default:
            return '';
        }
      },
    },
    methods: {
      summaryClicked() {
        this.$emit('summaryClicked');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .in-journey-accordion-summary {
    width: 100%;
    padding: 0;

    .bordered-section {
      background-color: #f2f2f2;
      display: flex;
      color: #ed0080;
      align-items: center;
      padding-left: 11px;
      padding-right: 6px;
      padding-top: 17px;
      padding-bottom: 17px;

      .left {
        flex: 1;
        padding-right: 4px;
        p {
          margin: 0;
          font-size: 16px;
          font-weight: 600;
          line-height: 18px;
        }
      }

      .right {
        padding-left: 4px;
        p {
          margin: 0;
          font-size: 16px;
          font-weight: 600;
          line-height: 22px;
          text-wrap: nowrap;
        }
      }
    }
  }
</style>
<style lang="scss">
  .in-journey-accordion-summary {
    .description-section {
      padding: 12px;
      padding-bottom: 0;

      p {
        margin: 0;
        font-size: 16px;
        font-style: italic;
        font-weight: 400;
        line-height: 18px;

        span:first-of-type {
          color: #ed0080;
          font-size: 16px;
          font-weight: 600;
          line-height: 18px;
          text-decoration: underline;
        }
        span:last-of-type {
          font-size: 16px;
          font-weight: 600;
          line-height: 18px;
          text-decoration: underline;
        }
      }
    }
  }

  @media screen and (max-width: 740px) and (min-width: 0px) {
    .in-journey-accordion-summary {
      .description-section {
        padding-left: 0;
        padding-right: 0;
      }
    }
  }
</style>
